const tl = gsap.timeline({
  defaults: { duration: 2, opacity: 0, ease: "back.out(1.7)" },
});
tl.from(".hero-head", { x: -200 })
  .from(".hero-details", { x: -200 }, "<0.5")
  .from(".hero-img", { x: 500 }, "<0.75");
gsap.fromTo(
  ".card-grid",
  { y: 100, opacity: 0 },
  {
    scrollTrigger: ".row",
    y: 0,
    duration: 1,
    opacity: 1,
    stagger: 0.25,
    ease: "back.out(4)",
  }
);
gsap.fromTo(
  ".email-cont",
  { x: -100, opacity: 0 },
  {
    scrollTrigger: ".email-row",
    x: 0,
    duration: 1,
    opacity: 1,
    stagger: 0.25,
    ease: "back.out(4)",
  }
);

gsap.fromTo(
  ".feat",
  { y: 100, opacity: 0 },
  {
    scrollTrigger: ".feat2",
    y: 0,
    duration: 1.5,
    opacity: 1,
    stagger: 0.5,
    ease: "back.out(4)",
  }
);

///////////////////////////
// MODAL
///////////////////////////
const images = document.querySelectorAll(".email-image");
const modal = document.querySelector(".modal");
const modalimage = document.querySelector(".modalimage");
const overlay = document.querySelector(".overlay");

const closemodal = function () {
  modal.classList.add("hidden");
  overlay.classList.add("hidden");
};
images.forEach((image) => {
  image.addEventListener("click", function () {
    console.log("ck");
    modal.classList.remove("hidden");
    overlay.classList.remove("hidden");
    if (image.dataset.src) {
      modalimage.src = image.dataset.src;
    } else {
      modalimage.src = image.src;
    }
  });
});
document.addEventListener("keydown", function (e) {
  e.preventDefault();
  if (e.key === "Escape") closemodal();
});
overlay.addEventListener("click", closemodal);

///////////////////////////
// MODAL FOOTER
///////////////////////////
const modals = document.querySelectorAll(".modalmain");
// const overlay = document.querySelector(".overlay");
const btnsOpenModal = document.querySelectorAll(".footer-links");
const btnsCloseModal = document.querySelectorAll(".close-modal, .overlay");

const openModal = (e) => {
  e.preventDefault();
  console.log("clikc");
  console.log(e.target);
  const x = e.target.dataset.label;
  console.log(x);
  const modalx = document.querySelector(".modal-" + x);
  console.log(modalx);
  modalx.classList.remove("hidden");
  overlay.classList.remove("hidden");
};

const closeModal = () => {
  modals.forEach((modal) => modal.classList.add("hidden"));
  overlay.classList.add("hidden");
};

btnsOpenModal.forEach((btn) => btn.addEventListener("click", openModal));
btnsCloseModal.forEach((btn) => btn.addEventListener("click", closeModal));

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeModal();
});